import React from 'react';

const LabelOutline = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 14" {...props}>
    <path
      fillRule="evenodd"
      d="M14.63.84C14.27.33 13.67 0 13 0L2 .01C.9.01 0 .9 0 2v10c0 1.1.9 1.99 2 1.99L13 14c.67 0 1.27-.33 1.63-.84L19 7 14.63.84zM13 12H2V2h11l3.55 5L13 12z"
    />
  </svg>
);

export default LabelOutline;
